import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { selectUser } from "../../redux/auth/selectors";
import ChangePasswordForm from "../forms/ChangePasswordForm";
import EditProfileForm from "../forms/EditProfileForm";
import { USERS_ACTIONS } from "../../redux/users/actions";
import { updatePassword } from "../../services/api/auth";
import { toast } from "react-toastify";
import {defaultError, defaultSuccess, goToTop} from "../../libs/utils";

class _ProfileEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      passwordProcessing: false
    };

    this._handlePasswordChange = this._handlePasswordChange.bind(this);
    this._handleEdit = this._handleEdit.bind(this);
  }

  static propTypes = {
    user: PropTypes.object,
    updateUser: PropTypes.func
  };

  _handleEdit(values) {
    const data = {
      firstName: values.firstname,
      email: values.email
    };

    if (values.gender && values.gender !== "") {
      data.gender = values.gender;
    }

    if (values.lastname && values.lastname !== "") {
      data.lastName = values.lastname;
    }

    if (values.size && values.size !== "") {
      data.size = values.size;
    }

    if (values.telephone && values.telephone !== "") {
      data.telephone = values.telephone;
    }

    if (values.dateofbirth && values.dateofbirth !== "") {
      data.birthDate = values.dateofbirth.format("YYYY-MM-DD");
    }

    this.props.updateUser(this.props.user.id, data, undefined, "/profile");
  }

  _handlePasswordChange(values) {
    this.setState({ passwordProcessing: true });
    updatePassword(this.props.user.id, {
      currentPassword: values.old_password,
      newPassword: values.new_password
    })
      .then(response => {
        defaultSuccess("Password Changed!")
        this.setState({ passwordProcessing: false });
        goToTop();
      })
      .catch(e => {
        defaultError("Something went wrong")
        this.setState({ passwordProcessing: false });
        goToTop();
      });
  }

  render() {
    const { user } = this.props;

    return (
      <div
        className="m-portlet__body m-form m-form--fit m-form--label-align-right"
        style={{
          paddingLeft: "0px",
          paddingRight: "0px"
        }}
      >
        <div className="form-group m-form__group m--margin-top-10 m--hide">
          <div className="alert m-alert m-alert--default" role="alert">
            The example form below demonstrates common HTML form elements that
            receive updated styles from Bootstrap with additional classes.
          </div>
        </div>
        <EditProfileForm user={user} onSubmit={this._handleEdit} />

        <div className="m-form__seperator m-form__seperator--dashed m-form__seperator--space-2x" />
        <ChangePasswordForm
          user={user}
          onSubmit={this._handlePasswordChange}
          isSubmitting={this.state.passwordProcessing}
        />
      </div>
    );
  }
}

const mapStateToProps = function(state) {
  return {
    user: selectUser(state)
  };
};

const mapDispatchToProps = dispatch => ({
  updateUser: (id, values, permissions, redirect) =>
    dispatch(USERS_ACTIONS.updateRequest(id, values, permissions, redirect))
});

const ProfileEdit = connect(mapStateToProps, mapDispatchToProps)(_ProfileEdit);

export default ProfileEdit;
